import styled from 'styled-components';
import {StyledProps} from './typings';
import breakpoint from '../../theme/constants/breakpoints';

const gap = '5px';
const galleryGap = '20px';

const position = {
  right: `${galleryGap} 0 ${galleryGap} auto`,
  center: `${galleryGap} auto`,
  left: `${galleryGap} auto ${galleryGap} 0`,
};

const StyledPagination = styled.nav<StyledProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: ${(props) => position[props.$position]};

  > *:not(:last-child) {
    margin-right: ${gap};
  }

  @media only screen and ${breakpoint.device.s} {
    width: fit-content;
  }
`;

export default StyledPagination;
